module.exports = __webpack_public_path__ + "static/media/StarFilled.3f3e7ab6.svg";